"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FutureBills_1 = require("./FutureBills");
exports.default = FutureBills_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/FutureBills/index.js
// module id = 789
// module chunks = 8